<template>
<div>
  <the-header />
  <div class="container">
    <h1>404</h1>
  </div>
</div>
</template>

<script>
  import TheHeader from '@/common/TheHeader'
  /**
   * Component is shows when route isn't defined
   */
  export default {
    name: 'NotFound',
    components: {
      TheHeader
    }
  }
</script>

<style scoped>

</style>
